import { useEffect, useState } from 'react';
import type { Size } from './Sizes';
import { MIN_MAX_WIDTHS } from './Sizes';

export function responsiveSize() {
  const width = window?.innerWidth;

  if (width === undefined) return null;

  return Object.keys(MIN_MAX_WIDTHS).find((size) => {
    const [min, max] = MIN_MAX_WIDTHS[size as Size];

    return width >= min && width < max;
  });
}

export function useIsSize(size: Size, { skipResizeListener = false } = {}) {
  const [currentSize, setCurrentSize] = useState(responsiveSize());

  useEffect(() => {
    if (skipResizeListener) return undefined;

    const handleResize = () => {
      const newCurrentSize = responsiveSize();
      if (newCurrentSize !== currentSize) {
        setCurrentSize(newCurrentSize);
      }
    };

    window.addEventListener('resize', handleResize, { passive: true });

    return () => window.removeEventListener('resize', handleResize);
  }, [currentSize, skipResizeListener]);

  return size === currentSize;
}

export default function isSize(size: Size) {
  return responsiveSize() === size;
}
